export default function ($translate) {
    return {
        KEYS: {
            SEND_INDIVIDUAL_NOTIFICATIONS: 'SEND_INDIVIDUAL_NOTIFICATIONS',
            SEND_COURSE_NOTIFICATION: 'SEND_COURSE_NOTIFICATION',
            DO_NOT_SEND_NOTIFICATION: 'DO_NOT_SEND_NOTIFICATION'
        },
        LABELS: {
            SEND_INDIVIDUAL_NOTIFICATIONS: $translate.instant('events.SEND_INDIVIDUAL_NOTIFICATIONS'),
            SEND_COURSE_NOTIFICATION: $translate.instant('events.SEND_COURSE_NOTIFICATION'),
            DO_NOT_SEND_NOTIFICATION: $translate.instant('events.DO_NOT_SEND_NOTIFICATION'),
            SEND_NOTIFICATION_FOR_ALL_COURSES: $translate.instant('events.SEND_NOTIFICATION_FOR_ALL_COURSES'),
            SEND_NOTIFICATION_FOR_EXTERNAL_COURSES_ONLY: $translate.instant('events.SEND_NOTIFICATION_FOR_EXTERNAL_COURSES_ONLY')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/event/action/index.js